import new_germany from "../images/newProductPage/languages/DE.png";
import new_spanish from "../images/newProductPage/languages/ES.png";
import new_french from "../images/newProductPage/languages/FR.png";
import new_italy from "../images/newProductPage/languages/IT.png";
import new_niderland from "../images/newProductPage/languages/ND.png";
import new_polish from "../images/newProductPage/languages/PL.png";
import new_portugal from "../images/newProductPage/languages/PR.png";
import new_russia from "../images/newProductPage/languages/RU.png";
import new_england from "../images/newProductPage/languages/UK.png";
import screen1 from "../images/newProductPage/estonian/1.png";
import screen2 from "../images/newProductPage/estonian/2.png";
import screen3 from "../images/newProductPage/estonian/3.png";
import screen4 from "../images/newProductPage/estonian/4.png";

import dlaczego1 from "../images/newProductPage/why/dlaczego_1.webp";
import dlaczego2 from "../images/newProductPage/why/dlaczego_2.webp";
import dlaczego3 from "../images/newProductPage/why/dlaczego_3.webp";
import zdjecie2 from "../images/newProductPage/mission/latop_square.png";
import zdjecie3 from "../images/newProductPage/mission/people_square.png";
import zdjecie1 from "../images/newProductPage/mission/women_square.png";

export const estonian = {
  navbar: {
    data: [
      { title: "Telli kursus", path: "/course" },
      { title: "Registreeru", path: "/start" },
      { title: "Keeletik", path: "/" },
      { title: "Meist", path: "/about" },
      { title: "Arvustused", path: "/reviews" },
    ],
  },
  mainPage: {
    product_page: {
      faq: {
        title: "Korduma kippuvad küsimused",
        subtitle: "Kas sul on küsimusi? Meil on vastused.",
        sections: [
          {
            title: "Keeletiku kohta",
            questions: [
              {
                question: "Mis on Keeletik?",
                answer:
                  "Keeletik on veebipõhine platvorm võõrkeelte õppimiseks, mis võimaldab kiiresti ja tõhusalt omandada rääkimise ja mõistmise oskused praktikas.",
              },
              {
                question: "Kuidas Keeletik keelekursused toimivad",
                answer:
                  "Pärast registreerimist saad juurdepääsu interaktiivsetele veebitundidele ja materjalidele, mida saad läbida endale sobival ajal. Kursused on kohandatud sinu tasemele ja eesmärkidele.",
              },
              {
                question: "Kas Keeletik tõesti aitab rääkimisoskust arendada?",
                answer:
                  "Jah. Meie kursused keskenduvad praktilisele suhtlemisele – tänu interaktiivsetele harjutustele ületad kiiresti rääkimisbarjääri",
              },
            ],
          },
          {
            title: "Maksed ja tarne",
            questions: [
              {
                question: "Kuidas ma saan Keeletiku kursuse eest tasuda?",
                answer:
                  "Saad maksta internetis või kauba kättesaamisel kullerile.",
              },
              {
                question: "Kas minu andmed ja maksed on turvalised?",
                answer:
                  "Jah. Kõik andmed on kaitstud vastavalt GDPR-ile ja maksed – nii veebis kui ka kättesaamisel – on turvalised ning neid töötlevad usaldusväärsed partnerid.",
              },
              {
                question: "Kas maksmine kauba kättesaamisel on turvaline?",
                answer:
                  "Jah. Kuller toimetab paki kohale ja makse toimub turvaliselt kauba kättesaamisel.",
              },
              {
                question:
                  "Millal saan kursusele juurdepääsu pärast tellimuse tasumist?",
                answer:
                  "Juurdepääs aktiveeritakse automaatselt, sisestades koodi määratud lehele.",
              },
              {
                question: "Mis juhtub, kui ma pakki vastu ei võta?",
                answer:
                  "Kui sa pakki vastu ei võta, ei aktiveerita kursusele juurdepääsu. Kuid saad kursuse igal ajal uuesti tellida.",
              },
            ],
          },
          {
            title: "Turvalisus, usaldus ja tugi",
            questions: [
              {
                question: "Kas minu isikuandmed on Keeletikus turvalised?",
                answer:
                  "Jah. Me kasutame andmete krüpteerimist ja Euroopa standarditele vastavaid kaitsemeetmeid.",
              },
              {
                question:
                  "Kas Keeletik on seaduslik ja registreeritud ettevõte?",
                answer:
                  "Jah. Keeletik on haridusbränd, mis kuulub ettevõttele European Learning Agency. Ettevõte tegutseb seaduslikult ja on registreeritud Euroopa Liidus. Täpsema info leiad meie veebilehel olevatest tingimustest.",
              },
              {
                question:
                  "Kuidas ma saan Keeletiku klienditoega ühendust võtta?",
                answer:
                  "Saad kirjutada aadressile klienditugi@keeletik-edu.com või kasutada veebilehel olevat kontaktivormi.",
              },
              {
                question:
                  "Kas te pakute rahulolu garantiid või raha tagasi maksmist?",
                answer:
                  "Jah. Kui kursus ei vasta ootustele, pakume loobumis- või tagastusvõimalust vastavalt tingimustele – ilma riskita.",
              },
            ],
          },
        ],
      },
      language: "et",
      hero: {
        languages: [
          "inglise keeles",
          "hispaania keeles",
          "saksa keeles",
          "hollandi keeles",
          "itaalia keeles",
          "vene keeles",
          "poola keeles",
          "prantsuse keeles",
          "portugali keeles",
        ],
        title: "Räägi enesekindlamalt,",
        prefix: "enesekindlalt",
        subtitle:
          "Arendage oma keeleoskust meie tegelikel näidetel põhineva kursusega!",
        buttonText: "Telli kohe!",
      },
      learning: {
        title: "Kuidas kursus välja näeb?",
        config: [
          {
            image: screen1,
            category: "Õppige keelt kõige lihtsamal viisil",
            descriptions: [
              {
                bold: "Kümneid õppetunde",
                rest: "igapäevases suhtluses põhinevate näidetega.",
              },
              {
                bold: "Praktilised fraasid",
                rest: "emakeelsete kõnelejate koostatud.",
              },
              {
                bold: "Harjutused,",
                rest: "mis arendavad tõhusalt lugemis-, kuulamis- ja rääkimisoskust.",
              },
            ],
          },
          {
            image: screen2,
            category: "Praktilised õppetunnid",
            description:
              "Iga tasemekursus koosneb kümnetest teie vajadustele kohandatud õppetundidest.",
          },
          {
            image: screen3,
            category: "Ülesanded",
            description:
              "Meie harjutused toetavad tõhusalt materjali kordamist ja parandavad mälu.",
          },
          {
            image: screen4,
            category: "Sõnad, fraasid ja väljendid",
            description:
              "Iga õppetund sisaldab hoolikalt valitud pilte, mis muudavad õppimise intuitiivseks.",
          },
        ],
        photoData: [screen1, screen2, screen3, screen4],
      },
      languages: {
        languages: [
          { image: new_england, lang: "Inglise" },
          { image: new_french, lang: "Prantsuse" },
          { image: new_spanish, lang: "Hispaania" },
          { image: new_niderland, lang: "Hollandi" },
          { image: new_germany, lang: "Saksa" },
          { image: new_italy, lang: "Itaalia" },
          { image: new_russia, lang: "Vene" },
          { image: new_portugal, lang: "Portugali" },
          { image: new_polish, lang: "Poola" },
        ],
        title: "Saadaval keeled:",
        description:
          "Valmistuge järgmiseks reisiks või lisage keeleoskused oma CV-sse.",
      },
      expertSection: {
        title: "Teie keeleekspert",
        firstSectionTitle: "Tugi käeulatuses",
        firstSectionDescription: "Saage õppimise ajal täielik tugi!",
        secondSectionTitle: "Esitage küsimusi ja saage vastuseid",
        secondSectionDescription:
          "Kõiki küsimusi saate esitada otse oma ekspertile.",
        thirdSectionTitle: "Individuaalne lähenemine igal sammul",
        thirdSectionDescription:
          "Keeleeksperdi nõuannete kasutamine kiirendab teie õppimist.",
      },
      courseValue: {
        title: "Saage rohkem koos Keeletikuga",
        subtitle:
          "Mitte ainult keeleõpe – saate täieliku ligipääsu vahenditele",
        buttonText: "Telli kohe!",
        config: [
          {
            title: "Õpe kohandatud teie elustiiliga",
            sections: [
              {
                text: "Meie platvormiga saate õppida kus ja millal soovite.",
              },
              {
                text: "Lühikesed õppetunnid sobituvad ideaalselt teie päevakavasse.",
              },
            ],
          },
          {
            title: "Motivatsioon igal sammul",
            sections: [
              {
                text: "Hoidke motivatsiooni meie jälgimissüsteemi kaudu.",
              },
              {
                text: "Iga õppepäev viib teid sujuva suhtluse poole.",
              },
            ],
          },
          {
            title: "Täielik paindlikkus ja personaliseerimine",
            sections: [
              {
                text: "Kohandage kursus oma tasemele ja õppetemposse.",
              },
              {
                text: "Keskenduge sellele, mis teid kõige rohkem huvitab.",
              },
            ],
          },
        ],
      },
    },
  },
  aboutUs: {
    hero: {
      title: "Missioon",
      description: `Meie lõppeesmärk Keeletik keskkonnas on pakkuda kõigile juurdepääsu isiklikule õpetajale tehnoloogia kaudu. Usume, et keel on kultuuride vaheline sild ning meie missioon on ületada suhtlusbarjäärid ja tuua inimesi keeleõppe kaudu kokku.`,
    },
    why: {
      title: "Miks meie?",
      config: [
        {
          title: "Innovaatilised õpetamismetoodikad",
          image: dlaczego1,
          description:
            "Meie keerukas kuid praktikas tõestatud õppimisalgoritm kohandab õpimaterjalid teie praeguse teadmistasemega ja täiendab seda tõhusa õppimise kaudu.",
        },
        {
          title: "Lai keelevalik",
          image: dlaczego2,
          description:
            "Pakume kursusi maailma enimlevinud keeltes. See võimaldab teil valida keele, mis vastab teie vajadustele.",
        },
        {
          title: "Haridus lõbusal moel",
          image: dlaczego3,
          description:
            "Meie platvorm muudab keeleõppe lõbusaks ja nauditavaks kogemuseks, mis hoiab teid motiveerituna.",
        },
      ],
    },
    mission: {
      config: [
        {
          title: "Personaliseerimine ja juurdepääs",
          description:
            "Meie võimas masinõppe algoritm töötab pidevalt selle nimel, et pakkuda igale õppijale sobival tasemel õppematerjale. Keeletik võimaldab õppijatel mustreid iseseisvalt avastada, ilma et nad peaksid keskenduma keelereeglitele – samamoodi, nagu õppisite oma emakeelt lapsena.",
          image: zdjecie1,
        },
        {
          title: "Julge tehnoloogia ja teaduse kombinatsioon",
          description:
            "Keeletik kasutab julgelt tehnoloogia ja teaduse kombinatsiooni, et teie aju tegevusse sütitada. Lõputute sõnalistide ja fraaside kordamine on igav, ja teie aju teab seda. Meie meetod, mis aitab teil omandatud teadmisi erinevatel hetkedel erinevalt rakendada, on põnev ja tõhus – teie aju hindab seda!",
          image: zdjecie2,
        },
        {
          title: "Kogukond ja väärtus",
          description:
            "Keeled aitavad inimestel aktiivsed olla. Keeleõpe soodustab mõistmist. Keeletik kogukond ühendab inimesi üle kogu maailma. Oleme ambitsioonikad ja lükkame pidevalt piire. Usume, et keeleõpe peaks olema lõbus ja oleme uudishimulikud avastama uusi kultuure keelte kaudu.",
          image: zdjecie3,
        },
      ],
    },
  },
  formSender: {
    formControll: {
      pageLink: "https://nyelvfejlesztesi-kozpont.eu/",
      title: "Kas olete kursusest huvitatud?",
      title1: "Kas vajate rohkem teavet?",
      subtitle: "Jätke meile oma number – me helistame teile",
      subtitle1: "Kui teil on juba konto, täitke palun järgmised väljad:",
      button1: "Ees- ja perekonnanimi",
      button2: "Telefoninumber",
      button3: "E-post",
      buttonSub: "Soovin kõnet",
      checkOne:
        "Selle vormi esitamisega nõustun tingimustega ja kinnitan, et olen lugenud andmekaitse tingimusi ja eeskirju.",
      checkOneTwo: "ja",
      checkTwo:
        "Nõustun, et minuga võidakse turunduslikel eesmärkidel ühendust võtta.",
      textOne: "Anname teile teada, et",
      textTwo:
        "Teie isikuandmete haldur on EOU Sp. z o.o., registrikoodiga KRS 0001038089, REGON 525396900, NIP 5273057993, asukohaga Varssavis, Młynarska tn 42/115, 01-171, sisse kantud Varssavi ringkonnakohtu ettevõtjaregistrisse. Teie isikuandmeid töödeldakse seoses päringuga kontaktvormi kaudu või sõlmitud lepingu täitmiseks. Teie pöördumisega annate vabatahtlikult nõusoleku ülaltoodud eesmärkidel oma isikuandmete töötlemiseks. Teil on õigus juurdepääsule, andmete parandamisele, kustutamisele või töötlemise piiramisele, esitama vastuväiteid töötlemisele ja andmete ülekantavusele. Teil on samuti õigus igal ajal oma nõusolek tagasi võtta, kuid nõusoleku tagasivõtmine ei mõjuta enne tagasivõtmist õiguslikult kehtivat töötlemist. Teil on õigus esitada kaebus järelevalveasutusele. Andmete esitamine on vabatahtlik, kuid võib olla vajalik päringule vastamiseks või lepingu täitmiseks. Isikuandmeid säilitatakse nii kaua, kui on vaja eespool nimetatud eesmärkidel, kuid mitte kauem kui üldise seadusega ette nähtud pretensioonide aegumistähtaeg. Palume hoolikalt lugeda privaatsuspoliitikat.",
      buttonMore: "Loe rohkem",
      buttonLess: "Näita vähem",
      subOne: "teenuse osutamise tingimused",
      subTwo: "ja privaatsuspoliitikad.",
      buttonTXT: "Aitäh",
      rulesLink: "/Regulations_EN_European_Learning_Agency_keeletik.pdf",
      privacyLink: "/Privacy_EN_European_Learning_Agency.pdf",
      product: "ke",
      market: "ee",
      send_to_url: "https://crm.eou-edu.eu/api/v1/cms/create_order",
      utm_source: "Platform_Keeletik",
      product_variant: "et-en",
      server_link: "https://cms.eou-edu.eu/integration/lead-from-landing",
      currency: "eur",
      price: 89,
    },
  },
  reviews: {
    language: "et",
    title: "Keeletik arvustused",
    subtitle:
      "Teie tagasiside on oluline – Keeletik arvustused aitavad meil platvormi arendada vastavalt kasutajate vajadustele.",
    contentPlaceholder: "Alustage kirjutamist",
    submitButton: "Saada",
    thankYouText:
      "Aitäh, et jagasite oma kogemust ja aitate meil luua tõhusat keeleõppe tööriista!",
  },
  footer: {
    title: "Liitu meiega:",
    privacy: "Privaatsus",
    privacyLink: "/Privacy_EN_European_Learning_Agency.pdf",
    rules: "Teenuse osutamise tingimused",
    rulesLink: "/Regulations_EN_European_Learning_Agency_keeletik.pdf",
  },
};
